import React, { useState } from "react";
import { Formik } from "formik";

import {
  intlShape,
  apiShape,
  withApi,
  SwitchInput,
  Details,
  notifierShape,
  withNotifier,
  withIntl,
  userShape,
  withUser,
  ContextualHelp,
} from "lcm-iot-commons";
import { FormattedMessage } from "react-intl";

type Props = {
  intl: intlShape;
  user: userShape;
  api: apiShape;
  notifier: notifierShape;
  edgeId: number;
};

export function EdgeNotificationHandler({
  notifier,
  api,
  intl,
  user,
  edgeId,
}: Props) {
  const [state, setState] = useState({ offlineNotification: false });

  const baseKey = "eh.user_config.user_notifications.";
  const keySuffixes = {
    NOTIFICATION_VALUE: "status_offline",
  };

  const loadNotificationSpecifications = async () => {
    try {
      const notificationSpecifications = await api.get(
        `/edm/edge_devices/${edgeId}/specifications`,
        { key: `${baseKey}*` },
      );
      const currentState = {};

      if (
        !notificationSpecifications[
          `${baseKey}${keySuffixes.NOTIFICATION_VALUE}`
        ]
      ) {
        const params = {};
        // @ts-expect-error TS(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
        params[`${baseKey}${keySuffixes.NOTIFICATION_VALUE}`] = { value: "" };
        await api.patch(`/edm/edge_devices/${edgeId}/specifications`, params);
        (currentState as $TSFixMe).offlineNotification = false;
      } else {
        (currentState as $TSFixMe).offlineNotification =
          notificationSpecifications[
            `${baseKey}${keySuffixes.NOTIFICATION_VALUE}`
          ]?.value
            .split(";")
            .includes(user.id.toString());
      }

      // @ts-expect-error TS(2345) FIXME: Argument of type '{}' is not assignable to paramet... Remove this comment to see the full error message
      setState(currentState);
    } catch (error) {
      notifier.showError(api.translateError(error));
    }
  };

  React.useEffect(() => {
    loadNotificationSpecifications();
  }, []);

  const saveDemoDataActivationState = async () => {
    try {
      const notificationSpecifications = await api.get(
        `/edm/edge_devices/${edgeId}/specifications`,
        { key: `${baseKey}*` },
      );
      const notifiedUsers =
        notificationSpecifications[
          `${baseKey}${keySuffixes.NOTIFICATION_VALUE}`
        ]?.value.split(";");
      const userId = user.id.toString();
      if (state.offlineNotification) {
        const userIndex = notifiedUsers.indexOf(userId);
        if (userIndex > -1) {
          const params = {};
          notifiedUsers.splice(userIndex, 1);
          // @ts-expect-error TS(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
          params[`${baseKey}${keySuffixes.NOTIFICATION_VALUE}`] = {
            value: notifiedUsers.join(";"),
          };
          await api.patch(`/edm/edge_devices/${edgeId}/specifications`, params);
        }
      } else if (!notifiedUsers.includes(userId)) {
        const params = {};
        if (notifiedUsers[0] === "") {
          // @ts-expect-error TS(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
          params[`${baseKey}${keySuffixes.NOTIFICATION_VALUE}`] = {
            value: userId,
          };
        } else {
          notifiedUsers.push(userId);
          // @ts-expect-error TS(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
          params[`${baseKey}${keySuffixes.NOTIFICATION_VALUE}`] = {
            value: notifiedUsers.join(";"),
          };
        }
        await api.patch(`/edm/edge_devices/${edgeId}/specifications`, params);
      }
      setState({ ...state, offlineNotification: !state.offlineNotification });
      notifier.showSuccess(
        intl.formatMessage({
          id: "user_profile.notifications_success_notification",
        }),
      );
    } catch (apiErrors) {
      notifier.showError(api.translateError(apiErrors));
    }
  };
  const renderForm = (formProps: $TSFixMe) => (
    <>
      <h3 id="notification-switch-section">
        <FormattedMessage id="label.notifications" />
        <ContextualHelp
          title={intl.formatMessage({
            id: "edge_device_edit.user_notification.offline.hint_heading",
          })}
          interactive
        >
          <p>
            <FormattedMessage id="edge_device_edit.user_notification.offline.hint_text" />
            <FormattedMessage id="edge_device_edit.user_notification.offline.hint_text2" />
          </p>
        </ContextualHelp>
      </h3>
      <Details>
        <form id="demo-data-form" noValidate>
          <SwitchInput
            {...formProps}
            id="demo-data-switch-input"
            values={{ "demo-data-switch-input": state.offlineNotification }}
            handleChange={saveDemoDataActivationState}
            name="demo-data-switch-input"
          />
        </form>
      </Details>
    </>
  );

  return (
    <Formik
      id="demo-data-formik"
      initialValues={{}}
      onSubmit={/* istanbul ignore next */ () => {}}
    >
      {renderForm}
    </Formik>
  );
}

export default withNotifier(
  withUser(withApi(withIntl(EdgeNotificationHandler))),
);
